module.exports = __webpack_public_path__ + "img/cases-brand-maxam-lazyload-101.3e4e62e2.jpg";